import { useToggle } from '@glow/common'
import { createContext, ReactNode, useMemo, useState } from 'react'
import { useLocation } from 'react-router'

export interface AppMenuContextValue {
  expanded: boolean
  menuWidthPx: number
  menuWidthWithPaddingPx: number
  lastSelectedPlannerDepartment?: string
  toggleExpanded: () => void
  setPlannerDepartment: (id: string) => void
}

const LayoutCardPadding = 64
export const initialAppMenuContextValue: AppMenuContextValue = {
  expanded: true,
  menuWidthPx: 0,
  menuWidthWithPaddingPx: LayoutCardPadding,
  lastSelectedPlannerDepartment: undefined,
  toggleExpanded: () => {},
  setPlannerDepartment: () => {}
}
export const AppMenuContext = createContext<AppMenuContextValue>(initialAppMenuContextValue)

export const AppMenuProvider = ({ children }: { children: ReactNode }) => {
  const location = useLocation()
  const [expanded, toggleExpanded] = useToggle(true)
  const menuWidth = useMemo(() => (expanded ? 256 : 72), [location.pathname, expanded])
  const [lastSelectedPlannerDepartment, setPlannerDepartment] = useState<string>()

  return (
    <AppMenuContext.Provider
      value={{
        expanded,
        menuWidthPx: menuWidth,
        lastSelectedPlannerDepartment,
        menuWidthWithPaddingPx: menuWidth + LayoutCardPadding,
        toggleExpanded,
        setPlannerDepartment
      }}
    >
      {children}
    </AppMenuContext.Provider>
  )
}
